import  { useEffect, useState } from "react";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { CloseIcon, FilterIcon, filterBlackIcon } from "../../../assets/images";
import { DropDown } from "../../commons";


type Appprops = {
  type?: string;
  toggle: boolean;
  setToggle: (data: boolean) => void;
  handleLoctionChange: (data: any) => void;
  locationListValue: any;
  selectLoction: any;
  filterConditionData: any;
  setFilterConditionData: any;
  departmentListValue?: any;
  handleApplyFilterData: () => void;
  handleDepartmentChange?: (data: any) => void;
  selectDepartment?: any;
  clearFilter: () => void;
  setMultiSelectData: any;
  multiSelectData: any;
  qrCodeToggle: number;
  setQRCodeToggle: any;
  multiFilterMaintain: any;
  setSelectLoction: any;
  setMultiFilterMaintain: any;
  history: any;
};
const FixedAssetFilter = ({
  type,
  toggle,
  handleLoctionChange,
  handleDepartmentChange,
  departmentListValue,
  selectDepartment,
  setToggle,
  selectLoction,
  locationListValue,
  filterConditionData,
  setFilterConditionData,
  handleApplyFilterData,
  clearFilter,
  setMultiSelectData,
  multiSelectData,
  setQRCodeToggle,
  qrCodeToggle,
  multiFilterMaintain,
  setSelectLoction,
  setMultiFilterMaintain,
  history,
}: Appprops) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const filterCount: number = Object.values({
      Obsolete: multiFilterMaintain?.Obsolete,
      Missing: multiFilterMaintain?.Missing,
      Good: multiFilterMaintain?.Good,
      Bad: multiFilterMaintain?.Bad,
      to_capitalize: multiFilterMaintain?.to_capitalize,
    }).filter((value) => value === true).length;

    let showFilterCount =
      filterCount && selectLoction?.value && qrCodeToggle === 1
        ? filterCount + 2
        : filterCount && (selectLoction?.value || qrCodeToggle === 1)
        ? filterCount + 1
        : filterCount
        ? filterCount
        : selectLoction?.value && qrCodeToggle === 1
        ? 2
        : selectLoction?.value || qrCodeToggle === 1
        ? 1
        : 0;
    setCount(selectDepartment?.value ? showFilterCount + 1 : showFilterCount);
  }, [multiFilterMaintain]);

  const handleConditionFilterChange = (data: string) => {
    setFilterConditionData(() => {
      return {
        ...filterConditionData,
        [data]: !filterConditionData[data],
      };
    });
  };

  const resetFilter = () => {
    const trueCount = Object.values({
      Obsolete: multiFilterMaintain?.Obsolete,
      Missing: multiFilterMaintain?.Missing,
      Good: multiFilterMaintain?.Good,
      Bad: multiFilterMaintain?.Bad,
      to_capitalize: multiFilterMaintain?.to_capitalize,
    }).filter((value) => value === true).length;
    const showFilterCount =
      trueCount &&
      multiFilterMaintain?.location.value &&
      multiFilterMaintain?.qrCode === 1
        ? trueCount + 2
        : trueCount &&
          (multiFilterMaintain?.location.value ||
            multiFilterMaintain?.qrCode === 1)
        ? trueCount + 1
        : trueCount
        ? trueCount
        : multiFilterMaintain?.location.value &&
          multiFilterMaintain?.qrCode === 1
        ? 2
        : multiFilterMaintain?.location.value ||
          multiFilterMaintain?.qrCode === 1
        ? 1
        : 0;
    setCount(showFilterCount);
    setFilterConditionData(() => {
      return {
        Obsolete: false,
        Missing: false,
        Good: false,
        Bad: false,
        to_capitalize: false,
      };
    });
    setQRCodeToggle(0);
    setMultiSelectData([]);
    setSelectLoction({
      label: "Select",
      value: null,
      logo: "",
    });
  };

  const empty = () => {
    setFilterConditionData({
      Obsolete: multiFilterMaintain?.Obsolete,
      Missing: multiFilterMaintain?.Missing,
      Good: multiFilterMaintain?.Good,
      Bad: multiFilterMaintain?.Bad,
      to_capitalize: multiFilterMaintain?.to_capitalize,
    });
    setQRCodeToggle(multiFilterMaintain?.qrCode);
    setSelectLoction({
      label: multiFilterMaintain?.location?.label,
      value: multiFilterMaintain?.location.value,
      logo: multiFilterMaintain?.location?.logo?.file_url,
    });
  };
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        count === 0 && toggle ? resetFilter() : empty();
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="#262a44"
        style={{
          border: "1px solid #bfcbe1",
          backgroundColor: "#ffffff",
          height: "38px",
        }}
      >
        <img src={count ? FilterIcon : filterBlackIcon} alt="" />
        <span className={count ? "filter-count" : ""}>
          <span>{count > 0 ? count : ""}</span>
        </span>
      </DropdownToggle>
      <DropdownMenu
        right
        style={{
          width: type === "mobileDevice" ? "270px" : "400px",
          padding: "15px 25px 30px",
        }}
      >
        <div className="d-flex justify-content-between mt-0 mb-0">
          <h5 className="text-center ">Filter</h5>
          <div
            className="pointer"
            onClick={() => {
              setToggle(!toggle);
            }}
          >
            <img src={CloseIcon} alt="" />
          </div>
        </div>
        {type === "mobileDevice" ? null : (
          <div>
            <hr className="mt-0 mb-2" />
            <span>Filter data</span>
          </div>
        )}

        {type === "mobileDevice" ? (
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="clientName">Department</label>
                <div>
                  <DropDown
                    options={departmentListValue}
                    value={selectDepartment}
                    handleChange={handleDepartmentChange}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="clientName">Location</label>
                <div>
                  <DropDown
                    options={locationListValue}
                    value={selectLoction}
                    handleChange={(e: any) => handleLoctionChange(e)}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* <div className="row"> */}
        <div className="form-group" style={{ margin: 0 }}>
          <label htmlFor="clientName">Condition</label>
        </div>
        <div className="">
          <div className="row mt-2 d-flex align-items-center">
            <div className="col-md-4">
              <div className="d-flex align-items-center justify-content-start mt-3 mb-2 ">
                <input
                  type="checkbox"
                  name="is_partner_field"
                  style={{
                    width: "19px",
                    height: "19px",
                    backgroundColor: "red",
                    accentColor: " #dd4433",
                  }}
                  onChange={(e) => handleConditionFilterChange("Obsolete")}
                  className="checkbox"
                  defaultChecked={filterConditionData?.Obsolete ? true : false}
                />
                <div>
                  <small
                    className="ml-2"
                    style={{ fontSize: "14px", color: "#262a44" }}
                  >
                    Obsolete
                  </small>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex mt-3 mb-2">
                <input
                  type="checkbox"
                  name="is_track_scheduling"
                  style={{
                    width: "19px",
                    height: "19px",
                    backgroundColor: "red",
                    accentColor: " #dd4433",
                  }}
                  defaultChecked={filterConditionData?.Missing ? true : false}
                  onChange={() => handleConditionFilterChange("Missing")}
                  className="checkbox"
                />
                <small
                  className="ml-2"
                  style={{ fontSize: "14px", color: "#262a44" }}
                >
                  Missing
                </small>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="row mt-2 d-flex align-items-center">
            <div className="col-md-4">
              <div className="d-flex align-items-center justify-content-start mt-3 mb-2 ">
                <input
                  type="checkbox"
                  name="is_partner_field"
                  style={{
                    width: "19px",
                    height: "19px",
                    backgroundColor: "red",
                    accentColor: " #dd4433",
                  }}
                  onChange={() => handleConditionFilterChange("Good")}
                  className="checkbox"
                  defaultChecked={filterConditionData?.Good ? true : false}
                />
                <div>
                  <small
                    className="ml-2"
                    style={{ fontSize: "14px", color: "#262a44" }}
                  >
                    Good
                  </small>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex mt-3 mb-2">
                <input
                  type="checkbox"
                  name="is_track_scheduling"
                  style={{
                    width: "19px",
                    height: "19px",
                    backgroundColor: "red",
                    accentColor: " #dd4433",
                  }}
                  defaultChecked={filterConditionData?.Bad ? true : false}
                  onChange={() => handleConditionFilterChange("Bad")}
                  className="checkbox"
                />
                <small
                  className="ml-2"
                  style={{ fontSize: "14px", color: "#262a44" }}
                >
                  Bad
                </small>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-2 mb-2 d-flex align-items-center">
          <div className="col-md-6">
            <div className="d-flex mt-3 mb-2">
              <input
                type="checkbox"
                name="is_track_scheduling"
                style={{
                  width: "19px",
                  height: "19px",
                  backgroundColor: "red",
                  accentColor: " #dd4433",
                }}
                defaultChecked={
                  filterConditionData?.to_capitalize ? true : false
                }
                onChange={() => handleConditionFilterChange("to_capitalize")}
                className="checkbox"
              />
              <small
                className="ml-2"
                style={{ fontSize: "14px", color: "#262a44" }}
              >
                Yet to Capitalize
              </small>
            </div>
          </div>
        </div>
        {/* </div> */}

        <div>
          <div className="form-group" style={{ margin: "0px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                gap: "3px",
              }}
            ></div>
          </div>
          {type === "mobileDevice" ? null : (
            <div>
              <div className="pt-2 pb-2">
                <span style={{ color: "#7c8db0" }}>QR Code Image</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "5%" }}>
                <label className="switchs m-0">
                  <input
                    type="checkbox"
                    checked={qrCodeToggle !== 0}
                    onChange={() => {
                      if (history?.location?.state) {
                        const newState = { ...history.location.state };
                        delete newState?.filterData?.qrcodeToggle;
                        history.replace({
                          ...history.location,
                          state: newState,
                        });
                      }
                      setQRCodeToggle(qrCodeToggle === 0 ? 1 : 0);
                    }}
                  />

                  <span
                    className="sliders rounds"
                    style={{
                      backgroundColor: !qrCodeToggle ? "gray" : "",
                    }}
                  ></span>
                </label>
                <div>Show Assets without QR Code</div>
              </div>
            </div>
          )}
        </div>

        <div className="d-flex align-items-center justify-content-end mt-3">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
              setMultiFilterMaintain({
                Obsolete: false,
                Missing: false,
                Good: false,
                Bad: false,
                qrCode: 0,
                location: {
                  label: "Select",
                  value: null,
                  logo: "",
                },
                department: {
                  label: "Select",
                  value: null,
                },
              });
            }}
          >
            Clear Filter
          </button>
          <button
            className="pl-4 pr-4 btn btn-primary"
            onClick={() => {
              handleApplyFilterData();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default FixedAssetFilter;
